import * as React from "react";
import { MoonLoader } from "react-spinners";
import styled from "styled-components";

import { Colors } from "src/library/utils";

import type { ILoaderStyled } from "./LoadingSpinner";

interface IMoonLoaderSpinner {
  size?: number;
  color: keyof Colors;
}

/**
 * Custom styled MoonLoader
 */
const MoonLoaderStyled = styled(MoonLoader).attrs(({ customColor, theme }: ILoaderStyled) => ({ color: theme && theme.colors ? theme.colors[ customColor ] : "#000000" }))<ILoaderStyled>`
  div {
    /* margin: auto; */
  }
`;

/**
 * A MoonLoader loading spinner
 */
const MoonLoaderSpinner = ({ size, color }: IMoonLoaderSpinner) => {
  const sizeDefault = 36;

  // Set option props with default values
  size = size || sizeDefault;

  return (
    <MoonLoaderStyled
      customColor={color}
      size={size}
    />
  );
};

export default MoonLoaderSpinner;
